import type {ButtonLinkProps, ContainerProps} from '@jetbrains/ring-ui/components/button/button'
import Button from '@jetbrains/ring-ui/components/button/button'
import classNames from 'classnames'
import React from 'react'
import type {To} from 'react-router-dom'
import {useHref, useLinkClickHandler} from 'react-router-dom'

import styles from './ButtonLink.css'

export type PipelineButtonLinkProps = Omit<ContainerProps<ButtonLinkProps>, 'href'> & {
  to: To
}

function ButtonLink({to, className, ...restProps}: PipelineButtonLinkProps) {
  const href = useHref(to)
  const onClick = useLinkClickHandler(to)
  return (
    <Button
      href={href}
      onClick={onClick}
      className={classNames(styles.button, className)}
      {...restProps}
    />
  )
}

export default ButtonLink
